// @index('./*', pp => `import * as ${pp.name} from '${pp.path}/index';`, { "ignore": ["./*.ts", "./*.md", "./setupTests.cjs"] })

// @endindex
// @index('./*.ts', pp => `import { ${pp.name} } from '${pp.path}';`)
import { EventAppInitialisedDetail } from './EventAppInitialisedDetail';
import { EventApplyFiltersDetail } from './EventApplyFiltersDetail';
import { EventDetailBase } from './EventDetailBase';
import { EventGlobalInputsChangeAttestationDetail } from './EventGlobalInputsChangeAttestationDetail';
import { EventGlobalInputsChangeDetail } from './EventGlobalInputsChangeDetail';
import { EventGlobalSearchChangeDetail } from './EventGlobalSearchChangeDetail';
import { EventPaginationChangeDetail } from './EventPaginationChangeDetail';
import { EventUpdateDetail } from './EventUpdateDetail';
import { EventUpdatePaginationDetail } from './EventUpdatePaginationDetail';
import { EventUpdateSharedFilterDetail } from './EventUpdateSharedFilterDetail';
// @endindex
export {
	// @index('./*', pp => `${pp.name},`, { "ignore": ["setupTests.cjs"]})
	EventAppInitialisedDetail,
	EventApplyFiltersDetail,
	EventDetailBase,
	EventGlobalInputsChangeAttestationDetail,
	EventGlobalInputsChangeDetail,
	EventGlobalSearchChangeDetail,
	EventPaginationChangeDetail,
	EventUpdateDetail,
	EventUpdatePaginationDetail,
	EventUpdateSharedFilterDetail,
	// @endindex
};



// WEBPACK FOOTER //
// ./src/models/eventManager/detail/index.ts